// components/Navbar.js
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../Hooks/useauthContext";
import "./Navbar.css";
import { useLogout } from "../Hooks/useLogout";

const Navbar = () => {
  const { user, authIsReady } = useAuthContext();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isDashboard, setIsDashboard] = useState(false);
  const location = useLocation();
  const { logout } = useLogout();
  const navigate = useNavigate();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // State for controlling the mobile menu
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (authIsReady && user) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
    if (location.pathname.startsWith("/dashboard")) {
      setIsDashboard(true);
    }
  }, [authIsReady, user]);

  // Toggle the menu on small screens
  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  // Close menu if user clicks a link
  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <header className="top-nav">
      {/* Left side: Logo */}
      <div className="nav-left">
        <Link to="/" onClick={handleLinkClick}>
          <img
            src="/robologo.png"
            alt="RoboFication Logo"
            className="logo-img"
          />
        </Link>
      </div>

      {/* Hamburger icon visible on small screens */}
      <div className="hamburger" onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>

      {/* 
        Nav items: only show if isMenuOpen = true on small screens,
        or always show on larger screens 
      */}
      <nav className={`nav-menu ${isMenuOpen ? "active" : ""}`}>
        <div className="nav-center" onClick={handleLinkClick}>
          <Link to="/about" className="midbtn">
            About
          </Link>
          <div className="navbar-dropdown">
            <div className="navbar-products-container">
              <Link to="/products" className="midbtn">
                Product
              </Link>
              <button
                className="navbar-dropdown-arrow"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsDropdownOpen(!isDropdownOpen);
                }}
              >
                {isDropdownOpen ? "▼" : "▶"}
              </button>
            </div>
            <div className={`navbar-dropdown-content ${isDropdownOpen ? "show" : ""}`}>
              <Link to="https://huddleroom.robofication.com/#/create-huddle-room">
                Robo Huddle Room
              </Link>
              <Link to="https://sysml.robofication.com/#/dashboard">
                Robo SysML
              </Link>
            </div>
          </div>
          <Link to="/contact-us" className="midbtn">
            Product Access
          </Link>
        </div>
        <div className="nav-right" onClick={handleLinkClick}>
          {isLoggedIn ? (
            isDashboard ? (
              <button onClick={handleLogout} className="dashboard-btn">
                Logout
              </button>
            ) : (
              <Link to="/dashboard" className="dashboard-btn">
                Dashboard
              </Link>
            )
          ) : (
            <>
              <Link to="/login" className="login-btn">
                Log in
              </Link>
              {/* <Link to="/register" className="signup-btn">
                Sign up
              </Link> */}
            </>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
